import journey from './api-partner-url/journey'
import monitoring from './api-partner-url/monitoring'
import order from './api-partner-url/order'
import sellingPrice from './api-partner-url/selling-price'
import settings from './api-partner-url/settings'
import trip from './api-partner-url/trip'
import utils from './api-partner-url/utils'
import vehicle from './api-partner-url/vehicle'

export default {
  trip,
  vehicle,
  journey,
  monitoring,
  settings,
  utils,
  order,
  sellingPrice
}
